import { environment } from '@environments/environment';

let config = {};

if (environment.production) {
  config = {
    apiKey: 'AIzaSyBT2xU_V4ZyWt97sIWTf4U9jCJFECT_As0',
    authDomain: 'speero-91382.firebaseapp.com',
    databaseURL: 'https://speero-91382.firebaseio.com',
    projectId: 'speero-91382',
    storageBucket: 'speero-91382.appspot.com',
    messagingSenderId: '572832613978',
    appId: '1:572832613978:web:839aac543b7c0b9e34ba63',
    measurementId: 'G-F7TYGPDZ4L'
  };
} else {
  config = {
    apiKey: 'AIzaSyAJcS1V-e2O6msQ7AJHXIIh15swqbgcy_c',
    authDomain: 'speero-customers-dev.firebaseapp.com',
    databaseURL: 'https://speero-customers-dev-default-rtdb.firebaseio.com',
    projectId: 'speero-customers-dev',
    storageBucket: 'speero-customers-dev.appspot.com',
    messagingSenderId: '365964231157',
    appId: '1:365964231157:web:12f721b7f853f2797f60bc',
    measurementId: 'G-W7QDF9RG8Q'
  };
}
export const FIREBASE_CONFIG = config;